module.exports = __webpack_public_path__ + "img/faq_btn.902da60d.svg";